module.exports = __webpack_public_path__ + "img/person-plus.a1183f66.svg";